module.exports = __webpack_public_path__ + "static/img/icon-foot-qr.fa51f72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-foot-qr.png
// module id = BABF
// module chunks = 1